import { warningsvg} from "../../assets/svg/svgimages";
import Select from "./Select";
import styles from "./Select.module.css"

const Occupation = ({ formData, handleChange, errors }) => {

  const occupations = [
    { id: 'Matchmove artist', label: 'Matchmove artist' },
    { id: 'On-set supervisor', label: 'On-set supervisor' },
    { id: 'VFX supervisor', label: 'VFX supervisor' },
    { id: 'Compositor', label: 'Compositor' },
    { id: 'DoP', label: 'DoP' },
    { id: 'VFX Artist', label: 'VFX Artist' },
    { id: 'Rental', label: 'Rental' },
    { id: 'Producer', label: 'Producer' },
    { id: 'Cameraman', label: 'Cameraman' },
    { id: '3D Modeler', label: '3D Modeler' },
    { id: 'Other', label: 'Other' },
  ];

  const handleOccupationSelect = (selectedId) => {
    handleChange({ target: { name: 'occupation', value: selectedId } });
  };

  return (
    <div className={styles.occupationCont}>
      <Select
        placeholder="Select your occupation"
        options={occupations}
        selected={formData.occupation}
        onSelect={handleOccupationSelect}
      />
      {errors.occupation && (
        <div className="error-message">
          {warningsvg} {errors.occupation}
        </div>
      )}
    </div>
  );
};

export default Occupation;